import { case_status_options, impact_options, workflow_stage_options, reach_options } from './incidents_cases_data';
import { case_drawers_primary } from './incidents_cases_drawers_primary';
import { case_drawers_secondary } from './incidents_cases_drawers_secondary';

export function create_report_form() {
  const report_form = {
    title: '',
    description: '',
    classification: 'Fraud concern',
    investigator: '',
    reported_by: '',
    workflow_stage: workflow_stage_options[0],
    impact: impact_options[2],
    reach: reach_options[2],
    status: case_status_options[0],
    confidential: false
  };
  return report_form;
}

export function clone_deep(value) {
  const cloned_value = JSON.parse(JSON.stringify(value));
  return cloned_value;
}

export const status_meta_from_label = (label) => {
  if (label === 'Escalated') return { label, class: 'bg-danger-subtle text-danger-emphasis' };
  const is_closed = label === 'Resolved' || label === 'Closed';
  if (is_closed) return { label, class: 'bg-success-subtle text-success-emphasis' };
  const warningBadge = {
    label,
    class: 'bg-warning-subtle text-warning-emphasis'
  };

  return warningBadge;
};

export const drawer_status_class = (status) => {
  if (status === 'Escalated') return 'risks-drawer-pill is-danger';
  if (status === 'Resolved' || status === 'Closed') return 'risks-drawer-pill is-success';
  return 'risks-drawer-pill is-warning';
};

export const action_status_class = (status) => {
  const complete_statuses = ['Done', 'Closed'];
  if (complete_statuses.includes(status)) return 'bg-success-subtle text-success-emphasis';
  if (status === 'Overdue') return 'bg-danger-subtle text-danger-emphasis';
  const open_statuses = ['Open', 'In progress'];
  if (open_statuses.includes(status)) return 'bg-warning-subtle text-warning-emphasis';
  return 'bg-light text-secondary border border-light';
};

export function record_icon_for_type(type) {
  const icon_map = {
    Supplier: 'bi-truck', Contract: 'bi-bezier2', Control: 'bi-shield-check', 'Corrective actions': 'bi-list-check',
    'Data privacy': 'bi-database-lock', Procurement: 'bi-cart', Finance: 'bi-wallet2', Employee: 'bi-person',
    Asset: 'bi-hdd-stack', Risk: 'bi-exclamation-triangle', Audit: 'bi-clipboard-check', Policy: 'bi-file-earmark-text',
    'IT security': 'bi-lock', Evidence: 'bi-folder2-open'
  };
  const record_icon = Reflect.get(icon_map, type) || 'bi-box-seam';
  return record_icon;
}

export const workflow_steps_for_stage = (active_stage) => {
  const current_index = Math.max(workflow_stage_options.indexOf(active_stage), 0);
  return workflow_stage_options.map((label, index) => ({
    label,
    state: index < current_index ? 'done' : index === current_index ? 'active' : 'pending'
  }));
};

function with_workflow(catalog) {
  const workflow_catalog = Object.fromEntries(
    Object.entries(catalog).map(([key, value]) => [key, { ...value, workflow: workflow_steps_for_stage(value.workflow_active) }])
  );
  return workflow_catalog;
}

export function build_case_drawer_catalog() {
  const case_drawer_catalog = {
    ...with_workflow(case_drawers_primary),
    ...with_workflow(case_drawers_secondary)
  };
  return case_drawer_catalog;
}

function case_primary_action(is_closed) {
  const primary_action = is_closed
    ? { label: 'Reopen', icon: 'bi-arrow-counterclockwise' }
    : { label: 'Advance stage', icon: 'bi-arrow-right' };
  return primary_action;
}

function case_summary_copy(description) {
  const summary_copy = description || 'Case created from report incident modal. Add evidence, root cause and corrective actions in the case file.';
  return summary_copy;
}

export function create_generic_case_drawer(row, form) {
  const is_closed = row.status.label === 'Closed';
  const primary_action = case_primary_action(is_closed);
  const impact_label = form.impact.split(' - ')[1];
  const reach_label = form.reach.split(' - ')[1];
  const score_note = `${impact_label} x ${reach_label}`;
  const summary_copy = case_summary_copy(form.description);
  const can_escalate = row.status.label !== 'Escalated' && !is_closed;
  const generic_case_drawer = {
    section: `Case - ${row.ref} - ${row.classification}`,
    title: row.case,
    subtitle: `Investigator ${row.investigator} - reported today`,
    status: row.status.label,
    classification: row.classification,
    score: `${row.severity}/25`,
    score_note,
    severity: row.severity_label,
    age: '0d',
    workflow: workflow_steps_for_stage(row.stage),
    workflow_active: row.stage,
    summary_heading: row.classification,
    summary_icon: 'bi-file-earmark-text',
    summary_copy,
    repeat_alert: '',
    connected_records: [],
    evidence: [],
    root_cause_summary: 'No root cause recorded - required before closure.',
    root_cause_tags: [],
    corrective_actions: [],
    escalations: [],
    confidential: form.confidential,
    primary_action_label: primary_action.label,
    primary_action_icon: primary_action.icon,
    can_escalate
  };
  return generic_case_drawer;
}
